import { render, staticRenderFns } from "./StructureBlockContentNodeView.vue?vue&type=template&id=98cf3340"
import script from "./StructureBlockContentNodeView.vue?vue&type=script&lang=js"
export * from "./StructureBlockContentNodeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports